import { useIntl } from "react-intl";
import React, { useState } from "react";
import ReactGA from "react-ga4";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

import {
  Banner,
  Content,
  Button,
  Icon,
  ReadyToStart,
  Layout,
  ItemList,
  Tips,
  TabBox,
  Column,
} from "../../components";
// import "../../components/Banner/Banner.scss";
import useAppContext from "../../context/Context";
import "./Atm.scss";
import cl from "../../banks/quickTransfer_CL.json";
import mx from "../../banks/quickTransfer_MX.json";
import "./Atm.scss";

import AtmTopSection from "../../assets/images/atm/AtmTopSection.png";
import ScreenAtm1 from "../../assets/images/atm/ScreenAtm1.png";
import ScreenAtm2 from "../../assets/images/atm/ScreenAtm2.png";
import ScreenAtm3 from "../../assets/images/atm/ScreenAtm3.png";

import ScreenAtmClient1 from "../../assets/images/atm/ScreenAtmClient1.png";
import ScreenAtmClient2 from "../../assets/images/atm/ScreenAtmClient2.png";
import ScreenAtmClient3 from "../../assets/images/atm/ScreenAtmClient3.png";

import PhoneAtm from "../../assets/images/atm/PhoneAtm.png";

gsap.registerPlugin(ScrollTrigger);

export const Atm = () => {
  document.title = "Retiros de efectivo | Etpay";
  ReactGA.send({ hitType: "pageview", page: "/eatm" });
  const { setStep, getImages, activeCountry } = useAppContext();
  const intl = useIntl();
  const color = "rgba(255, 190, 92, 1)";
  const [bankList, setBankList] = React.useState(null);

  React.useEffect(() => {
    setStep && setStep(1);
  }, []);

  const handleChangeBank = () => {
    activeCountry === "cl" ? setBankList(cl) : setBankList(mx);
  };

  // React.useEffect(() => {
  //   const anim = gsap
  //     .timeline({
  //       scrollTrigger: {
  //         trigger: "#move-start",
  //         start: "top 200px",
  //         end: "3100px 80%",
  //         scrub: true,
  //       },
  //     })
  //     .to("#move-video-quick", { transform: "translateY(1600px)" });

  //   return () => {
  //     anim.kill();
  //     // anim.scrollTrigger.kill();
  //   };
  // }, []);

  React.useEffect(handleChangeBank, [activeCountry]);

  const [openModal, setOpenModal] = useState(false);

  const changeModal = () => {
    setOpenModal(!openModal);
  };

  const tab1 = (
    <div className="tab-atm">
      <div className="item-tab">
        <div className="content-item">
          <span>Uno</span>
          <p>
            Ingresa el monto del retiro y el número de telefono de tu cliente.
          </p>
        </div>
        <div className="content-item-img">
          <img src={ScreenAtmClient1} alt="" />
        </div>
      </div>
      <div className="item-tab">
        <div className="content-item">
          <span>Dos</span>
          <p>Muestra el QR a tu cliente para seguir con el retiro.</p>
        </div>
        <div className="content-item-img">
          <img src={ScreenAtmClient2} alt="" />
        </div>
      </div>
      <div className="item-tab">
        <div className="content-item">
          <span>Tres</span>
          <p>Verifica la transacción y entrega el efectivo.</p>
        </div>
        <div className="content-item-img">
          <img src={ScreenAtmClient3} alt="" />
        </div>
      </div>
    </div>
  );

  const tab2 = (
    <div className="tab-atm">
      <div className="item-tab">
        <div className="content-item">
          <span>Uno</span>
          <p>Indica al cajero la cantidad de dinero que quieres retirar.</p>
        </div>
        <div className="content-item-img">
          <img src={ScreenAtm1} alt="" />
        </div>
      </div>
      <div className="item-tab">
        <div className="content-item">
          <span>Dos</span>
          <p>
            Escanea el código QR y autoriza la operación en la app de tu banco.
          </p>
        </div>
        <div className="content-item-img">
          <img src={ScreenAtm2} alt="" />
        </div>
      </div>
      <div className="item-tab">
        <div className="content-item">
          <span>Tres</span>
          <p>
            Comparte el código de verificación con el cajero para recibir el
            efectivo.
          </p>
        </div>
        <div className="content-item-img">
          <img src={ScreenAtm3} alt="" />
        </div>
      </div>
    </div>
  );

  return (
    <Layout className="quick-transfer">
      <Banner
        customClass="banner-atm"
        background={getImages["banner_background_atm"]}
      >
        <Content
          content={
            <div className="banner-top-icon margin-banner-atm">
              <div>
                <svg
                  width="34"
                  height="34"
                  viewBox="0 0 50 50"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect
                    width="49.0707"
                    height="49.0707"
                    rx="6.92763"
                    fill="#F2F2F2"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M31.3252 29.3828C37.7514 29.3828 42.9609 24.1733 42.9609 17.7471C42.9609 11.3208 37.7514 6.11133 31.3252 6.11133C24.8989 6.11133 19.6895 11.3208 19.6895 17.7471C19.6895 17.9911 19.697 18.2334 19.7118 18.4737H30.5984V29.3605C30.8388 29.3753 31.0811 29.3828 31.3252 29.3828Z"
                    fill="#FFBE5C"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M18.4737 19.6917C18.2362 19.6773 17.9967 19.6699 17.7556 19.6699C11.3246 19.6699 6.11133 24.8832 6.11133 31.3142C6.11133 37.7451 11.3246 42.9584 17.7556 42.9584C24.1865 42.9584 29.3998 37.7451 29.3998 31.3142C29.3998 31.0729 29.3925 30.8334 29.378 30.5958H18.4737V19.6917Z"
                    fill="#FFBE5C"
                  />
                </svg>
              </div>
              <p>eATM | Retiro de efectivo</p>
            </div>
          }
          title={"El cajero virtual para tu negocio"}
          subtitle={
            "Ofrece a tus clientes la posibilidad de retirar efectivo desde su cuenta bancaria sin tarjeta solo con su celular."
          }
          footer={
            <>
              <a
                target="_blank"
                href="https://dashboard.etpay.com/sign-up"
                rel="noreferrer"
              >
                <Button bgColor={color} bgHoverColor="#140F33" color="#fff">
                  <Icon name={"Icon_Pre"} fill="#fff" />
                  <span>
                    {intl.formatMessage({ id: "button.testFree.text" })}
                  </span>
                </Button>
              </a>

              {/* <a href={
                'tel:' + intl.formatMessage({ id: "banner.home.button2.url" })
              }>
                <Button bgColor={"#F2F2F2"} bgHoverColor="#140F33">
                  <span>
                    {intl.formatMessage({ id: "banner.home.button2.text" }) + intl.formatMessage({ id: "banner.home.button2.url" })}
                  </span>
                  <Icon name="icon-phone"></Icon>
                </Button>
              </a> */}
            </>
          }
          customClass="grid-5"
        />
        <div
          className="image-banner"
          style={{
            gridColumn: "8 / 13",
            marginTop: 0,
            overflow: "hidden",
          }}
        >
          <img src={AtmTopSection} alt="" />
        </div>
      </Banner>
      <Tips
        tip1={
          "<b>Atrae nuevos clientes: </b>ofrece un nuevo servicio y genera más ventas."
        }
        tip2={
          "<b>Sin letras pequeñas: </b>no pagues comisiones adicionales por tener el servicio"
        }
        tip3={
          "<b>Protege tu caja: </b>controla tu flujo de efectivo de manera más segura."
        }
      ></Tips>
      <div>
        <section className="section-competitionAtm">
          <div className="competition-content">
            <span style={{ color: color }}>Diferénciate de la competencia</span>
            <h4>Rápido y sencillo, sin necesidad de tarjeta.</h4>
            <p>
              Retiros de efectivo en tu comercio con las mejores comisiones del
              mercado.
            </p>
          </div>
        </section>
        <div className="img-phone">
          <img src="/content/phone-atm.png" alt="" />
        </div>
        <div className="container-list-section">
          <section className="contigo">
            <div className="contigo-content-text">
              <h3 className="contigo-title">Contigo en todo momento</h3>
              <p className="contigo-p">
                Consigue más clientes potenciando la visibilidad en tu comercio.
              </p>
              <p className="contigo-p">
                Ofrece la mejor experiencia con nuestro respaldo, soporte
                integral y atención personalizada.
              </p>
            </div>
            <div className="contigo-content-img">
              <img src="/content/etpay_atm_services.png" alt="" />
            </div>
            <div className="contigo-content-img img-responsive">
              <img src="/content/img-responsive-contigo.png" alt="" />
            </div>
            <div className="contigo-content-img img-responsive">
              <img src="/content/atm-responsive-contigo2.png" alt="" />
            </div>
          </section>
          <div className="container-list-atm">
            <div className="container-img-list atmDivPhoneDesktop">
              <img src={PhoneAtm} alt="" />
            </div>
            <div className="container-list">
              <h3>Mejor que un cajero automático</h3>
              <p className="subtitle-list">
                Diseñado para garantizar la mejor experiencia:
              </p>
              <div className="items-list-atm">
                <div className="container-check">
                  <ItemList>
                    <Icon name={"Check-atm"}></Icon>
                    <p>
                      <span className="bold">Fácil de implementar.</span> Sin
                      trámites complicados ni contratos fijos.
                    </p>
                  </ItemList>
                  <ItemList>
                    <Icon name={"Check-atm"}></Icon>
                    <p>
                      <span className="bold">Plataforma fácil de usar.</span>{" "}
                      Revisa el detalle de tus retiros y comisiones.
                    </p>
                  </ItemList>
                  <ItemList>
                    <Icon name={"Check-atm"}></Icon>
                    <p>
                      <span className="bold">Es seguro.</span> Los datos de tus
                      clientes están siempre protegidos.
                    </p>
                  </ItemList>
                  <ItemList>
                    <Icon name={"Check-atm"}></Icon>
                    <p>
                      <span className="bold">Aumenta tus ingresos.</span>{" "}
                      Beneficios en menos de 48 horas.
                    </p>
                  </ItemList>
                  <ItemList>
                    <Icon name={"Check-atm"}></Icon>
                    <p>
                      <span className="bold">Controla una red de cajeros</span>{" "}
                      si tienes más de una sucursal.
                    </p>
                  </ItemList>
                </div>
                <div className="atmDivPhoneMobile">
                  <img src={PhoneAtm} alt="" />
                </div>
                <div className="container-check">
                  <ItemList>
                    <Icon name={"Check-atm"}></Icon>
                    <p>
                      <span className="bold">Flexible.</span> Elige montos
                      máximos, horarios y disponibilidad.
                    </p>
                  </ItemList>
                  <ItemList>
                    <Icon name={"Check-atm"}></Icon>
                    <p>
                      <span className="bold">
                        Lo que tus clientes necesitan.
                      </span>{" "}
                      Las mejores comisiones del mercado.
                    </p>
                  </ItemList>
                  <ItemList>
                    <Icon name={"Check-atm"}></Icon>
                    <p>
                      <span className="bold">Multibanco.</span> Todos los bancos
                      en un solo lugar.
                    </p>
                  </ItemList>
                  <ItemList>
                    <Icon name={"Check-atm"}></Icon>
                    <p>Y más...</p>
                  </ItemList>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="container-compatarive">
          <h1 className="title-comparative-section">
            Sencillo, rápido y accesible{" "}
          </h1>
          <p className="subtitle-comparative-section">
            Sin necesidad de tarjeta
          </p>
          <TabBox
            customClass={"buttons-atm-tab"}
            tabList={["Comercio", "Clientes"]}
            tabContent={[tab1, tab2]}
            className="tab-box"
          ></TabBox>
          <div className="tarifas">
            <Column>
              <h4 className="top-title" style={{ color: color }}>
                Beneficios
              </h4>
              <h2 className="title">Haz crecer tu caja</h2>
              <h3 className="sub-title">
                Gana dinero ofreciendo retiros en efectivo a tus clientes.
              </h3>
            </Column>
            <Column customClass="content comisiones1">
              {/* 1 */}
              <div className="title hide-xs">Negocios y comercios</div>
              <div className="text">
                <div className="title show-xs">Negocios y comercios</div>
                <div className="description">
                  La mejor opción para pequeños comercios y negocios
                  independientes.
                </div>
              </div>
              <div className="value">
                <div className="top">
                  <div className="bottom">
                    <a
                      className="bottom-contact bottom-contact-atm-desktop"
                      href="mailto:ventas.mexico@etpay.com"
                    >
                      Te contactamos
                      <Icon name={"Icon_After"} color="#140f33" />
                    </a>
                    <a
                      className="bottom-contact bottom-contact-atm-mobile"
                      href="mailto:ventas.mexico@etpay.com"
                    >
                      Te contactamos
                    </a>
                  </div>
                </div>
              </div>
            </Column>
            <Column customClass="content comisiones2">
              {/* 1 */}
              <div className="title hide-xs">Cadenas y franquicias</div>
              <div className="text">
                <div className="title show-xs">Cadenas y franquicias</div>
                <div className="description">
                  Una opción adaptable y personalizable para todas tus
                  sucursales.
                </div>
              </div>
              <div className="value">
                <div className="top">
                  <div className="bottom">
                    <a
                      className="bottom-contact bottom-contact-atm-desktop"
                      href="mailto:ventas.mexico@etpay.com"
                    >
                      Te contactamos
                      <Icon name={"Icon_After"} color="#140f33" />
                    </a>
                    <a
                      className="bottom-contact bottom-contact-atm-mobile"
                      href="mailto:ventas.mexico@etpay.com"
                    >
                      Te contactamos
                    </a>
                  </div>
                </div>
              </div>
            </Column>
          </div>
        </div>
        <ReadyToStart></ReadyToStart>
      </div>
    </Layout>
  );
};
